import { css } from 'linaria';

export const subtitleStyles = css`
  margin: 0 0 var(--space-100);
  min-height: 20px;
`;
